import { Injectable, Pipe, PipeTransform } from '@angular/core';
import moment = require('moment-timezone');
import { AppTextService } from '../app-text';
import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/operators';

// note: use in combination with async pipe
@Pipe({
    name: 'fiTimeAgoPipe$',
    standalone: false,
})
@Injectable()
export class FiTimeAgoPipe implements PipeTransform {
    private readonly updateIntervalMS: number = 60000; // 1 min

    constructor(private appTextService: AppTextService) {}

    transform(value: string): Observable<string> {
        return timer(0, this.updateIntervalMS).pipe(map(() => this.getTimeAgoLabel(value)));
    }

    private getTimeAgoLabel(value: string): string {
        const nowMoment: moment.Moment = moment(new Date());
        const createdOnMoment: moment.Moment = moment(value);
        const minutesDiff: number = nowMoment.diff(createdOnMoment, 'minutes');
        const hoursDiff: number = nowMoment.diff(createdOnMoment, 'hours');
        if (hoursDiff > 0) {
            const label: string = hoursDiff > 1 ? 'checklist.n_hours' : 'checklist.n_hour';
            return (
                this.appTextService.get(label, { '{n}': hoursDiff }) +
                ' ' +
                this.appTextService.get('common.ago').toLowerCase()
            );
        }
        if (minutesDiff > 0) {
            const label: string = minutesDiff > 1 ? 'checklist.n_minutes' : 'checklist.n_minute';
            return (
                this.appTextService.get(label, { '{n}': minutesDiff }) +
                ' ' +
                this.appTextService.get('common.ago').toLowerCase()
            );
        }
        return this.appTextService.get('common.just_now');
    }
}
